module.exports = __webpack_public_path__ + "static/media/asp.net.5b02b6f3.png";